<template>
  <div :class="!showSlideBar ? 'slideOutLeftAni slideBar' : 'slideBar'">
    <span class="abs block people"></span>
    <span class="abs block cursor font_store" @click="gotoStore"></span>
    <span class="abs block cursor circle" @click="gotoStore"></span>
    <span class="abs block cursor close" @click="closeDialog"></span>
  </div>
</template>

<script>
export default {
  name: 'SliderBar',
  props: {
    options: Object,
  },
  data(){
    return {
      showSlideBar: true,
    }
  },
  methods: {
    closeDialog(){
      this.showSlideBar = !this.showSlideBar;
    },
    gotoStore(){
      this.$router.push('/gameStoreCenter');
    }
  }
}
</script>

<style lang="stylus" scoped>
.slideBar
  width 200px
  height 330px
  position fixed
  top calc(50% - 165px)
  right 52px
  z-index 9
  .people
    width 174px
    height 234px
    left calc(50% - 87px)
    top 0
    background url("../../assets/imgs/slideBar/role.png") no-repeat
    background-size 100% 100%
    animation upDown 1.5s linear infinite
  .font_store
    width 161px
    height 164px
    left calc(50% - 80.5px)
    top 130px
    background url("../../assets/imgs/slideBar/no_fire_center.png") no-repeat
    background-size 100% 100%
  .circle
    width 159px
    height 137px
    left calc(50% - 79.5px)
    top 132px
    background url("../../assets/imgs/slideBar/fire_circle.png") no-repeat
    background-size 100% 100%
    animation rotate360 3s linear infinite
  .close
    width 46px
    height 44px
    left calc(50% - 23px)
    bottom -5px
    background url("../../assets/imgs/slideBar/close.png") no-repeat
    background-size 100% 100%
    &:hover{
      transition transform .3s linear
      transform scale(1.1)
    }

</style>
